import { MdClose, MdMenuBook, MdHelpOutline } from 'react-icons/md';

export default function ReaderCheckModal({ open, loading, error, questions, onContinue, onGoBack, onRetry, onPublishDirectly }) {
  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onGoBack}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 560, borderRadius: 16, overflow: 'hidden' }}>
        <div style={{ background: '#FEF3C7', padding: '18px 24px', borderBottom: '1px solid #FDE68A', display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 38, height: 38, borderRadius: '50%', background: '#FDE68A', color: '#92400E', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, flexShrink: 0 }}>
            <MdMenuBook />
          </div>
          <div style={{ flex: 1 }}>
            <h3 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: '#78350F' }}>Reader Check</h3>
            <p style={{ margin: 0, fontSize: 12.5, color: '#92400E', marginTop: 2 }}>
              Reading this as a first-time reader, before checking style & grammar.
            </p>
          </div>
          <button className="modal-close" onClick={onGoBack}><MdClose /></button>
        </div>

        <div className="modal-body" style={{ padding: 24, maxHeight: '55vh', overflowY: 'auto' }}>
          {loading && (
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#475569', fontSize: 14 }}>
              📖 Reading your article as a first-time reader would...
            </div>
          )}

          {!loading && error && (
            <div style={{ background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 10, padding: 16, color: '#991B1B', fontSize: 13.5 }}>
              <strong>Reader check failed:</strong> {error}
            </div>
          )}

          {!loading && !error && (
            <>
              <p style={{ margin: '0 0 14px', fontSize: 14, color: '#334155' }}>
                Before checking style &amp; grammar, a few things aren't clear to me as a reader:
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {questions.map((q, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, background: '#FFFBEB', border: '1px solid #FDE68A', borderRadius: 8, padding: '10px 12px' }}>
                    <MdHelpOutline color="#B45309" size={18} style={{ flexShrink: 0, marginTop: 1 }} />
                    <span style={{ fontSize: 14, color: '#78350F', fontWeight: 500 }}>{q}</span>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>

        <div className="modal-footer" style={{ padding: '16px 24px', background: '#F8FAFC', borderTop: '1px solid #E2E8F0', display: 'flex', gap: 10, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
          {!loading && error && (
            <>
              <button className="btn btn-ghost" onClick={onGoBack}>Cancel</button>
              <button className="btn btn-ghost" onClick={onRetry}>Retry</button>
              {onPublishDirectly ? (
                <button className="btn btn-primary" onClick={onPublishDirectly}>Skip AI &amp; Publish</button>
              ) : (
                <button className="btn btn-primary" onClick={onContinue}>Skip &amp; Continue</button>
              )}
            </>
          )}
          {!loading && !error && (
            <>
              <button className="btn btn-ghost" onClick={onGoBack}>Go Back &amp; Add Details</button>
              <button className="btn btn-primary" onClick={onContinue}>This Is All The Info — Continue</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
